import React, { useState } from "react";
import { toast } from "sonner";
import { Save, Loader2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth } from "@/lib/auth-context";
import { auth as authApi } from "@/lib/api";

export default function Settings() {
  const { merchant, refresh } = useAuth();
  const [form, setForm] = useState({
    business_name: merchant?.business_name || "",
    category: merchant?.category || "",
  });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await authApi.updateOnboarding(form);
      await refresh();
      toast.success("Pengaturan disimpan");
    } catch { toast.error("Gagal simpan"); }
    setSaving(false);
  };

  return (
    <div className="space-y-6 max-w-3xl">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-gray-900">Pengaturan</h1>
        <p className="text-sm text-gray-500 mt-1">Kelola profil brand dan preferensi toko Anda.</p>
      </div>

      <Card className="border-gray-200">
        <CardContent className="p-6 space-y-4">
          <h3 className="font-heading font-semibold text-gray-900">Profil Brand</h3>
          <div><Label>Nama Brand / Toko</Label><Input value={form.business_name} onChange={(e) => setForm({ ...form, business_name: e.target.value })} data-testid="settings-name" /></div>
          <div>
            <Label>Kategori Produk</Label>
            <Select value={form.category} onValueChange={(v) => setForm({ ...form, category: v })}>
              <SelectTrigger data-testid="settings-category"><SelectValue placeholder="Pilih kategori" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="beauty">Skincare & Beauty</SelectItem>
                <SelectItem value="fashion">Fashion</SelectItem>
                <SelectItem value="food">Makanan & Kopi</SelectItem>
                <SelectItem value="pet_care">Pet Care</SelectItem>
                <SelectItem value="baby_care">Baby Care</SelectItem>
                <SelectItem value="herbal">Herbal / FMCG</SelectItem>
                <SelectItem value="household">Household</SelectItem>
                <SelectItem value="other">Lainnya</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <Button onClick={save} disabled={saving} className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="settings-save-btn">
            {saving ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Save className="mr-2 h-4 w-4" />}
            Simpan Perubahan
          </Button>
        </CardContent>
      </Card>

      <Card className="border-gray-200">
        <CardContent className="p-6">
          <h3 className="font-heading font-semibold text-gray-900">Info Akun</h3>
          <div className="mt-4 grid sm:grid-cols-2 gap-3 text-sm">
            <div><span className="text-gray-500">Owner:</span> <span className="font-semibold text-gray-900">{merchant?.owner_name}</span></div>
            <div><span className="text-gray-500">Email:</span> <span className="font-semibold text-gray-900">{merchant?.email}</span></div>
            <div><span className="text-gray-500">WhatsApp:</span> <span className="font-semibold text-gray-900">{merchant?.phone}</span></div>
            <div><span className="text-gray-500">Plan:</span> <span className="font-semibold text-emerald-600 capitalize">{merchant?.subscription_plan}</span></div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
